var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",class:{
    sep: _vm.separator,
    gutter: _vm.gutter,
    baseline: _vm.baseline,
    mouseover: _vm.isMouseOver,
    titlebar: _vm.titleBar
  },staticStyle:{"width":"100%"},style:({
    'padding-left': _vm.px + 'px',
    'padding-right': _vm.px + 'px',
    'padding-top': _vm.paddingY,
    'padding-bottom': _vm.paddingY,
    'flex-grow': _vm.grow ? 1 : 0,
    display: _vm.flex ? 'flex' : null,
    'background-color': _vm.color,
    'text-align':
      _vm.right || _vm.textRight ? 'right' : _vm.center || _vm.textCenter ? 'center' : ''
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }